<template>
  <v-sheet>
    <v-tabs v-model="tab">
      <v-tabs-slider color="accent" />
      <v-tab
        key="tab-item-0"
      >
        SQL Servers
      </v-tab>
      <v-tab
        key="tab-item-1"
      >
        SQL Load Balancers
      </v-tab>
    </v-tabs>
    <v-tabs-items
      v-model="tab"
    >
      <v-tab-item
        key="tab-item-0"
      >
        <items-tab 
          :itemProps="sqlserverProps"
        />
      </v-tab-item>
      <v-tab-item
        key="tab-item-1"
      >
        <items-tab 
          :itemProps="sqllbProps"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-sheet>
</template>
<script>
  export default {
    name: 'SqlTabs',
      data () {
        return {
          tab: 0,
          sqlserverProps: {
            headers: [
              { text: 'Name', value: 'sql_server_name' },
              { text: 'IP', value: 'sql_server_ip' },
              { text: 'Region', value: 'region_id' },
              { text: 'Primary Server', value: 'primary_server' },
              { text: 'Actions', value: 'actions', sortable: false },
            ],
            editedItem: {
              sql_server_name: '',
              sql_server_ip: '',
              region_id: '',
              primary_server: '',
            },
            defaultItem: {
              sql_server_name: '',
              sql_server_ip: '',
              region_id: '',
              primary_server: '',
            },
            itemsDispatch: 'settings/load_sql_servers',
            itemsGetter: 'settings/sql_servers',
            title: 'SQL Server',
            toolbarTitle: 'SQL Servers',
            apiUrl: '/v2/servers/sql/',
            uniqueId: 'sql_server_id'
          },
          sqllbProps: {
            headers: [
              { text: 'Name', value: 'sql_load_balancer_ip' },
              { text: 'Region', value: 'region_id' },
              { text: 'Primary SQL Server', value: 'primary_server_id' },
              { text: 'Secondary SQL Server', value: 'secondary_server_id' },
              { text: 'Availability Group', value: 'availability_group' },
              { text: 'Customer AG', value: 'customer_ag' },
              { text: 'Actions', value: 'actions', sortable: false },
            ],
            editedItem: {
              sql_load_balancer_ip: '',
              region_id: '',
              availability_group: '',
            },
            defaultItem: {
              sql_load_balancer_ip: '',
              region_id: '',
              availability_group: '',
            },
            itemsDispatch: 'settings/load_sql_load_balancers',
            itemsGetter: 'settings/sql_load_balancers',
            title: 'SQL Load Balancer',
            toolbarTitle: 'SQL Load Balancers',
            apiUrl: '/v2/sql_load_balancers/',
            uniqueId: 'sql_load_balancer_id'
          }
        }
      }
  }
</script>